import React from "react";
import SectionCommonTable from "../../components/SectionCommonTable";
import DirectBonusTable from "./Table/directBonusTable";

const DirectBonusPage = () => {
  return (
    <SectionCommonTable
      wrapperClassName="directbonus_table"
      cardStyle={{ backgroundColor: "#fff" }}
      sectionTableTitle="Direct Bonus"
      table={<DirectBonusTable />}
    />
  );
};

export default DirectBonusPage;
